import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { UserService } from '@core/services/user/user.service';
import { NavigationService } from '@core/navigation/navigation.service';
import { ProductService } from '@core/services/product/product.service';
import { ClasseService } from '@core/services/classe/classe.service';
import { CompanyService } from '@core/services/company/company.service';
import { BrancheService } from '@core/services/branche/branche.service';
import { EntitySuperiorService } from '@core/services/entity-superior/entity-superior.service';
import { BrokerService } from '@core/services/broker/broker.service';
import { MarketLevelOrganizationService } from '@core/services/market-level-organization/market-level-organization.service';

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(
        private _userService: UserService,
        private _navigationService: NavigationService,
        private _productService: ProductService,
        private _classeService: ClasseService,
        private _companyService: CompanyService,
        private _brancheService: BrancheService,
        private _brokerService: BrokerService,
        private _marketLevelOrganizationService: MarketLevelOrganizationService,
    ) { }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        // Fork join multiple API endpoint calls to wait all of them to finish


        return forkJoin([
            this._navigationService.get(),
            this._userService.get(),
            this._productService.getproductsAll(),
            this._classeService.getclassesAll(),
            this._companyService.getCompaniesAll(),
            this._brancheService.getBranchesAll(),
            this._productService.getproductsAll(),
            this._marketLevelOrganizationService.getAll(),
            this._brokerService.getAll()
        ])
    }


}
